export default __webpack_public_path__ + "static/media/008-jellyfish.eed8ad6b.svg";